import * as React from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import {
  ButtonGroup,
  IconButton,
  Hero,
  Subtitle,
  Title,
  RouteWrapper,
} from '../../components';
import { removeBooking } from '../../redux/actions/bookings';

interface Props {
  match: any;
  handleRemoveBooking: Function;
}

const Route = ({ match, handleRemoveBooking }: Props) => (
  <RouteWrapper
    title="Remove Booking"
    requireAuth
    requirePermission="MANAGE_BOOKINGS"
  >
    <Hero className="is-danger is-fullheight has-text-centered">
      <Title large>Remove Booking?</Title>
      <Subtitle>
        Once this booking is removed, you will not be able to access it or any
        of it's associated data in any way.
      </Subtitle>
      <ButtonGroup>
        <IconButton
          className="button is-danger is-large is-outlined is-inverted"
          handleClick={() => {
            handleRemoveBooking(match.params.id);
          }}
          icon="trash"
          large
        >
          Remove Booking
        </IconButton>
        <IconButton
          className="button is-danger is-outlined is-large is-inverted"
          link={`/bookings/${match.params.id}`}
          icon="undo"
          large
        >
          Cancel
        </IconButton>
      </ButtonGroup>
    </Hero>
  </RouteWrapper>
);

const mapDispatchToProps = (dispatch) => ({
  handleRemoveBooking: (id) => {
    dispatch(removeBooking(id)).then((response) => {
      if (!response.error) {
        dispatch(goBack());
        dispatch(goBack());
      } else {
        dispatch(goBack());
      }
    });
  },
});

export default connect(
  () => ({}),
  mapDispatchToProps,
)(Route);
